import { ReactNode } from 'react'

import Default from '@/assets/images/Default@3x.png'
import dayjs from 'dayjs'
import { Image } from 'antd-mobile'
import { cn } from '@/utils'

interface PropsIn {
  className?: string
  extra?: ReactNode
  children?: ReactNode
  onClick: () => void
  userData: unknown
}

const GlobalCard = (props: PropsIn) => {
  const { className, extra, children, userData, onClick } = props
  return (
    <div className={cn('rounded-[15px] bg-discover-global-card-bg-color p-[30px]', className)} onClick={onClick}>
      <div className={cn('mb-[30px] flex w-full items-center justify-between')}>
        <div className={cn('flex h-[45px] w-full items-center')}>
          <Image
            src={(userData as Record<string, string>).publisher_avatar || (userData as Record<string, string>).user_avatar}
            className={cn('mr-[7px] h-[45px] w-[45px] shrink-0 rounded-full')}
            fallback={<img src={Default} className={cn('mr-[7px] h-[45px] w-[45px] shrink-0 rounded-full')} width='100%' height='100%' />}
            placeholder={<img src={Default} className={cn('mr-[7px] h-[45px] w-[45px] shrink-0 rounded-full')} width='100%' height='100%' />}
          />
          <div className={cn('mr-[22px] flex h-full flex-1 flex-col justify-between')}>
            <span className={cn('line-clamp-1 flex-shrink-0 break-all font-geologica text-[19px] font-normal text-color-white-trans70')}>
              {(userData as Record<string, string>).publisher_name || (userData as Record<string, string>).user_nickname}
            </span>
            <span className={cn('font-geologica text-[15px] font-normal text-color-white-trans40')}>
              {(userData as Record<string, number>).created_at
                ? dayjs((userData as Record<string, number>).created_at * 1000).format('D MMMM, YYYY')
                : ''}
            </span>
          </div>
        </div>

        {extra ? extra : null}
      </div>
      {children ? children : null}
    </div>
  )
}

export default GlobalCard
